var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-icon",style:('width:'+ _vm.size + '; height:' + _vm.size)},[_c('img',{style:('width:'+ _vm.size + '; height:' + _vm.size),attrs:{"src":_vm.src,"alt":""},on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }